import { faSchool } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * Educational institution item interface for ui_metadata storage
 */
export interface EducationalInstitutionItem {
  id: string;
  displayLabel: string;
  name: string;
}

/**
 * Transform API response ({ id, name }) to EducationalInstitutionItem format.
 * Handles both suggestion API results and ui_metadata hydration items.
 */
export const transformEducationalInstitution = (apiItem: {
  id: string | number;
  name?: string;
}): EducationalInstitutionItem => {
  const id = String(apiItem?.id ?? '');
  const name = apiItem?.name || id;
  return {
    id,
    displayLabel: name,
    name,
  };
};

/**
 * Modal configuration for Educational Institution selector
 */
export const educationalInstitutionModalConfig: GenericSelectorModalConfig<EducationalInstitutionItem> =
  {
    title: 'Select Educational Institutions',
    searchPlaceholder: 'Search educational institutions...',
    emptyStateIcon: faSchool,
    emptyStateMessage: 'No educational institutions selected',
    noResultsMessage: (searchTerm) =>
      `No educational institutions found for "${searchTerm}"`,
    colorTheme: 'amber',
    selectionMode: 'multiple',
    showConnectorToggle: true,
    defaultConnector: 'ANY',
    getItemLabel: (item) => item.displayLabel,
    getItemSecondaryLabel: () => null,
    getItemKey: (item) => item.id,
    isItemSelected: (item, selectedItems) =>
      selectedItems.some((s) => s.id === item.id),
    itemLabel: 'educational institution',
    itemLabelPlural: 'educational institutions',
  };

/**
 * Node display configuration for Educational Institution
 */
export const educationalInstitutionNodeConfig: GenericNodeComponentConfig<EducationalInstitutionItem> =
  {
    colorTheme: 'amber',
    getItemLabel: (item) => item.displayLabel,
    getItemKey: (item) => item.id,
    maxVisibleItems: 2,
    showConnectorLabel: true,
  };
